export const typographyStyles = {
    components: {

        // Styling the <Input> Element
        Text: {
            baseStyle: {
                field: {
                    fontWeight: 400,
                    fontSize: '1.6rem',
                    color: "text.900",
                },
            },

            variants: {
                cardTitle: (props) => ({

                    fontSize: '2.4rem',
                    color: "text.900",
                    fontWeight: 700

                }),
            },
        },
    },
};
